import React, { useState, useRef, useEffect } from "react";
import { endPoints, P2PsportEndPoint, sportEndPoint } from "../../constant/Environment";
import {
  addData,
  addFormData,
  deleteData,
  getAllData,
  getAllFilterData,
  getAllSportData,
} from "../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";

import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../redux/Actions/Actions";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";

import Switch from "@mui/material/Switch";

const CreatePool = (props) => {
  const { onClose, editData, open, ...other } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [isActive, setIsActive] = useState(false);
  // new values
  const [poolPrice, setPoolPrice] = useState("");
  const [maxEntry, setMaxEntry] = useState("");
  const [entryperUser, setEntryperUser] = useState("");
  const [totalreward, setTotalReward] = useState("");
  const [sports, setSports] = useState([]);
  const [selectedsport, setSelcetedSport] = useState("");
  const [teamSize, setTeamSize] = useState("");
  const [winningPlayer, setWinningPlayer] = useState("");
  const [platformFee, setPlatformFee] = useState("");
  const [prizeBreakdown, setPrizeBreakdown] = useState([
    { position: "", payout: "" },
  ]);

  useEffect(() => {
    if (open && editData) {
      setTitle(editData?.title || "");
      setPoolPrice(editData?.price || "");
      setMaxEntry(editData?.poolSize || "");
      setEntryperUser(editData?.entryPerPlayer || "");
      setTeamSize(editData?.teamSize || "");
      setPlatformFee(editData?.platformFee || "");
      setWinningPlayer(editData?.winSize || "");
      setPrizeBreakdown(editData?.leatherboard || []);
      setIsActive(editData?.active || false);
      const matched = sports?.find((s) => s?.id === editData?.sport);
      setSelcetedSport(matched || null);
    }
  }, [open, editData]);

  const handleCancel = () => {
    onClose();
  };

  const handleOk = () => {
    if (!title ) {
    return ErrorToast("Title is required");
  }
  if (!poolPrice) {
    return ErrorToast("Pool price is required");
  }
  if (!teamSize) {
    return ErrorToast("Team size is required");
  }
  if (!maxEntry) {
    return ErrorToast("Pool Size is required");
  }
  if (!entryperUser) {
    return ErrorToast("Entry per player is reqiured");
  }
  if (!winningPlayer) {
    return ErrorToast("Winning players is required");
  }
  if (!selectedsport?.id) {
    return ErrorToast("Sport must be selected");
  }
  if (!platformFee) {
    return ErrorToast("platform fee is required");
  }
  if (winningPlayer >= maxEntry) {
    return ErrorToast("Winning players must be less than pool size");
  }

    let url = editData?.id
      ? `${P2PsportEndPoint.apiBaseUrl}${P2PsportEndPoint.api.UPDATE_POOLS}`
      : `${P2PsportEndPoint.apiBaseUrl}${P2PsportEndPoint.api.ADD_POOLS}`;
    let payload = {
      id: 0,
      title: title,
      entryPerPlayer: entryperUser,
      price: poolPrice,
      poolSize: maxEntry,
      winSize: winningPlayer,
      // leatherboard: prizeBreakdown,
      platformFee: platformFee,
      currency: "USD",
      teamSize: teamSize,
      sport: selectedsport.id,
      sportName: selectedsport.name,
      active: isActive,
    };
    if (editData?.id) {
      payload.id = editData.id;
    }
    setIsLoading(true);
    addData(url, payload)
      .then((response) => {
        setIsLoading(false);
        if (response.data.status === "success") {
          SuccesToast(response?.data?.message);
          onClose();
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast(error);
      });
  };

  const fetchsports = async (data) => {
    let url = `${P2PsportEndPoint.apiBaseUrl}${P2PsportEndPoint.api.sports}`;
    setIsLoading(true);
    await getAllSportData(url)
      .then((response) => {
        //  console.log("data", response);
        setIsLoading(false);
        if (response) {
          setSports(response);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  useEffect(() => {
    fetchsports();
  }, []);

  const addPrizeRow = () => {
    setPrizeBreakdown([...prizeBreakdown, { position: "", payout: "" }]);
  };

  const updatePrizeRow = (index, field, value) => {
    const updated = [...prizeBreakdown];
    updated[index][field] = value;
    setPrizeBreakdown(updated);
  };

  const deletePrizeRow = (index) => {
    const updated = prizeBreakdown.filter((_, i) => i !== index);
    setPrizeBreakdown(updated);
  };

  return (
    <Dialog
      sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 435 } }}
      maxWidth="md"
      open={open}
      {...other}
    >
      <DialogTitle>Pool Info </DialogTitle>

      <DialogContent dividers>
        <Toaster></Toaster>
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div className="row">
          <div className="col-md-6">
            <FormControl style={{ width: "100%", marginTop: "20px" }}>
              <TextField
                id="filled-required"
                variant="outlined"
                label="Pool Title"
                value={title}
                onChange={(event) => {
                  setTitle(event.target.value);
                }}
              />
            </FormControl>
          </div>

          <div className="col-md-6">
            <FormControl style={{ width: "100%", marginTop: "20px" }}>
              <TextField
                id="filled-required"
                variant="outlined"
                label="Pool Price"
                value={poolPrice}
                onChange={(event) => {
                  setPoolPrice(event.target.value);
                }}
              />
            </FormControl>
          </div>

          <div className="col-md-6">
            <FormControl style={{ width: "100%", marginTop: "20px" }}>
              <TextField
                id="filled-required"
                variant="outlined"
                label="Team Size"
                value={teamSize}
                onChange={(event) => {
                  setTeamSize(event.target.value);
                }}
              />
            </FormControl>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3 mt-3">
              <Form.Label>Sports</Form.Label>
              <Form.Select
                value={selectedsport?.id || ""}
                onChange={(event) => {
                  const selected = sports.find(
                    (item) => item.id.toString() === event.target.value
                  );
                  setSelcetedSport(selected);
                }}
              >
                <option value="">Select option</option>
                {sports.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3 mt-3">
              <Form.Label>Pool Size</Form.Label>
              <Form.Select
                value={maxEntry}
                onChange={(event) => setMaxEntry(Number(event.target.value))}
              >
                <option value="">Select option</option>
                {[...Array(100)].map((_, index) => (
                  <option key={index + 1} value={index + 1}>
                    {index + 1}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3 mt-3">
              <Form.Label>Entry Per User</Form.Label>
              <Form.Select
                value={entryperUser}
                onChange={(event) => setEntryperUser(event.target.value)}
              >
                <option value="">Select option</option>
                {[...Array(10)].map((_, index) => {
                  return (
                    <option key={index + 1} value={index + 1}>
                      {index + 1}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3 mt-3">
              <Form.Label>Winning Size</Form.Label>
              <Form.Select
                value={winningPlayer}
                onChange={(event) => setWinningPlayer(event.target.value)}
              >
                <option value="">Select option</option>
                {[...Array(10)].map((_, index) => {
                  const value = index + 2; // 3, 4, 5
                  return (
                    <option key={value} value={value}>
                      {value}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3 mt-3">
              <Form.Label>Platform Fee (%)</Form.Label>
              <Form.Select
                value={platformFee}
                onChange={(event) => setPlatformFee(event.target.value)}
              >
                <option value="">Select option</option>
                {[...Array(41)].map((_, index) => {
                  const value = index + 10;
                  return (
                    <option key={value} value={value}>
                      {value}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>
          </div>

          <div className="col-md-6">
            <FormControlLabel
              control={
                <Switch
                  name="active"
                  value={isActive}
                  onClick={() => {
                    setIsActive(!isActive);
                  }}
                  defaultChecked={isActive}
                />
              }
              labelPlacement="start"
              label="Active"
            />
          </div>
          {/* <div className="col-md-6"></div> */}

          {/* <div className="col-md-6">
            <FormControl style={{ width: "100%", marginTop: "20px" }}>
              <h5 className="mt-3">Prize Breakdown</h5>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Rank</th>
                    <th>Prize (₹)</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {prizeBreakdown.map((row, index) => (
                    <tr key={index}>
                      <td>
                        <Form.Control
                          type="text"
                          value={row.position}
                          onChange={(e) =>
                            updatePrizeRow(index, "position", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <Form.Control
                          type="text"
                          value={row.payout}
                          onChange={(e) =>
                            updatePrizeRow(index, "payout", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <Button
                          variant="danger"
                          onClick={() => deletePrizeRow(index)}
                          size="sm"
                        >
                          Delete
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <Button variant="success" onClick={addPrizeRow} size="sm">
                + Add Prize Row
              </Button>
            </FormControl>
          </div> */}
        </div>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel}>
          Cancel
        </Button>
        <Button onClick={handleOk}>Ok</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreatePool;
